import colors from './semanticColors';
import shadows from './shadows';

const semanticTokens = {
  colors,
  shadows,
};

export default semanticTokens;
